<div class="title">
    <span>{{ 'dashboard:Manage Categories' | i18next }} </span>
</div>
<div class="dialog-content">
    <div class="add-container">
        <app-widget-textbox [(model)]="category" title="{{ 'dashboard:Add Category (enter category name and press +)' | i18next }}"
            placeholder="Type here..." textboxWidth="435px"></app-widget-textbox>
        <i [ngClass]="['fas fa-plus-circle fa-lg', isAddDisabled() ? 'disabled-icon' : '']"
            (click)="addCategory()"></i>
    </div>
    <div class="exist-categories">
      {{ 'dashboard:Existing Categories' | i18next }}
    </div>
    <div class="exist-categories-container thin-scroll">
        <div class="category-row" *ngFor="let cat of existingCategories;let i = index;trackBy: customTrackBy">
            <app-widget-textbox [(model)]="existingCategories[i].category" textboxWidth="445px" [isExistCat]="true" [notifier]="notifier"
                [disabled]="existingCategories[i].disabled" (onEdit)="onEdit(i)"></app-widget-textbox>
            <i [ngClass]="['fas fa-trash-alt fa-sm', existingCategories[i].inUse === 1 ? 'disabled-icon' : '']" (click)="removeCategory(i)"></i>
            <i *ngIf="existingCategories[i].disabled" class="fas fa-pen fa-sm" (click)="editCategory(cat)"></i>
        </div>
    </div>
</div>

<mat-dialog-actions>
    <button mat-flat-button [ngClass]="['secondary-button']" (click)="onCancel()">{{ 'Cancel' | i18next }}</button>
    <button mat-flat-button [ngClass]="['primary-button']" (click)="onSave()" [disabled]="isSaveDisabled()">{{ 'Save' | i18next }}</button>
</mat-dialog-actions>
